import React from 'react';
import { IIconProps } from '../../interfaces';
const FacebookIcon = (props: IIconProps) => {
  /*w13 h16*/
  return (
      <svg width={props.width} height={props.height} viewBox="0 0 13 27" style={ props.style }>
          <title>{props.title}</title>
          <path d="M8.30176 26.1113V13.0547H11.9053L12.3838 8.55469H8.30176L8.30762 6.30273C8.30762 5.12891 8.41895 4.5 10.1045 4.5H12.3574V0H8.75293C4.42285 0 2.89844 2.18262 2.89844 5.85352V8.55469H0.200195V13.0547H2.89844V26.1113H8.30176Z" fill={ props.color ? props.color : 'black' } />
      </svg>
  )
};

export default FacebookIcon;